/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractApproveResponse = {
  type: 'Response',
} as const;
